/**
 * Converts normalized device coordinates to viewport coordinates.
 *
 * @param {{ x: number, y: number, z: number }} projectedPosition
 * @param {{ width: number, height: number }} viewport
 */
export function projectHotspot(projectedPosition, viewport) {
  const x = (projectedPosition.x * 0.5 + 0.5) * viewport.width;
  const y = (-projectedPosition.y * 0.5 + 0.5) * viewport.height;
  const visible =
    projectedPosition.z >= -1 &&
    projectedPosition.z <= 1 &&
    x >= 0 &&
    x <= viewport.width &&
    y >= 0 &&
    y <= viewport.height;

  return { x, y, visible };
}
